import { FC, useEffect, useState } from 'react';
import { Checkbox } from 'antd';

type Props = {
  label?: string;
  isChecked?: boolean;
};

export const CheckboxEditMode: FC<Props> = ({ label, isChecked }) => {
  const [checked, setChecked] = useState(isChecked);

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  return (
    <div data-testid="checkbox-component">
      <Checkbox
        className="ss-checkbox"
        checked={checked}
        onChange={(e) => setChecked(e.target.checked)}
      >
        {label}
      </Checkbox>
    </div>
  );
};
